export default "__VITE_ASSET__BiWRdPN___"